/* eslint-disable no-unused-vars */
import React from 'react';

import { useStateContext } from '../contexts/ContextProvider';

const LogoutButton = ({ icon, bgColor, color, bgHoverColor, size, text, borderRadius, width, onClickAction }) => {
  const { setIsClicked, initialState } = useStateContext();

  return (
    <button
      type="button"
      onClick={() => onClickAction()}
      style={{ backgroundColor: bgColor, color, borderRadius }}
      className={` text-${size} p-3 w-${width} hover:drop-shadow-xl hover:bg-${bgHoverColor}`}
    >
      {icon} {text}
    </button>
  );
};

export default LogoutButton;
